import { MatDialog } from '@angular/material';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs/Rx";
import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { SaveService } from '../services/save.service';

@Injectable()
export class AuthGuardAdmin implements CanActivate {


    constructor(private authService: AuthService,
        private router: Router,
        public dialog: MatDialog,
        private saveService: SaveService) {

    }

    canActivate(route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> {


        return this.authService.authInfo$
            .map(authInfo => authInfo.isLoggedIn() && (this.saveService.getUser().userType === 'ADMIN'))
            .take(1)
            .do(allowed => {
                if (!allowed) {
                    this.openDialog("Accès interdit", "Désolé vous devez vous connecter avec un compte de responsable d'institution pour être en mesure de sélectionner cette option")
                }
            });
    }

    openDialog(title, content): void {
        let dialogRef = this.dialog.open(ConfirmDialogComponent, {
            height: '250px',
            width: '300px',
            position: {'top':'150px'},
            data: {
                content: content,
                title: title,
                twoButton: false
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.router.navigate(['login']);
        });
    }

}


// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/security/auth.guard.admin.ts